import * as tslib_1 from "tslib";
import { Router } from '@angular/router';
import { ConfigService } from '../services/config.service';
import { AuthService } from '../services/auth.service';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../services/auth.service";
import * as i2 from "@angular/router";
import * as i3 from "../services/config.service";
export class CatalogueGuard {
    constructor(authService, router, configService) {
        this.authService = authService;
        this.router = router;
        this.configService = configService;
        this.loader$ = new Subject();
        this.loader = false;
        this.loader$.pipe(debounceTime(300)).subscribe(loader => { this.loader = loader; });
    }
    canActivate() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            console.debug("CatalogueGuard");
            this.setShowLoader(true);
            if (!this.configService.company_info)
                yield this.configService.getLoadedCompany();
            try {
                yield this.configService.getInitialInfo();
                var isLogged = yield this.authService.checkAutentication();
                if (isLogged)
                    yield this.configService.getInitialInfo(true);
                var isPublic = this.configService.company_info.company_catalogue_public;
            }
            catch (error) {
                this.setShowLoader(false);
                this.router.navigateByUrl('/autenticacion');
                return false;
            }
            if (isPublic || isLogged) {
                this.setShowLoader(false);
                return true;
            }
            this.setShowLoader(false);
            this.router.navigateByUrl('/autenticacion');
            return false;
        });
    }
    setShowLoader(show) {
        this.loader$.next(show);
    }
}
CatalogueGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CatalogueGuard_Factory() { return new CatalogueGuard(i0.ɵɵinject(i1.AuthService), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i3.ConfigService)); }, token: CatalogueGuard, providedIn: "root" });
